<script setup lang="ts">
import LoaderIcon from "@/components/icons/LoaderIcon.vue";
import { defineProps, defineEmits } from "vue";

defineProps<{
  disabled: boolean;
  loading: boolean;
  buttonText: string;
}>();

const emits = defineEmits(["click"]);
</script>

<template>
  <button
    class="w-full h-14 mb-4 rounded-full bg-orange-gradient"
    :class="{
      'opacity-40 pointer-events-none': disabled,
    }"
    @click="emits('click')"
  >
    <LoaderIcon v-if="loading" />
    <span
      v-else
      class="font-semibold text-white text-xl leading-[24px] select-none"
    >
      {{ buttonText }}
    </span>
  </button>
</template>
